var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.834 20C16.3568 20 20.834 15.5228 20.834 10C20.834 4.47715 16.3568 0 10.834 0C5.31114 0 0.833984 4.47715 0.833984 10C0.833984 15.5228 5.31114 20 10.834 20Z",
    fill: "#7BD6D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49999 13.1888L6.7819 10.487C6.70595 10.411 6.66797 10.3134 6.66797 10.194C6.66797 10.0746 6.70595 9.97699 6.7819 9.90103L7.38411 9.3151C7.46007 9.22829 7.55501 9.1849 7.66894 9.1849C7.78287 9.1849 7.88324 9.22829 7.97005 9.3151L9.79296 11.138L13.6992 7.23177C13.786 7.14497 13.8864 7.10156 14.0003 7.10156C14.1142 7.10156 14.2092 7.14497 14.2851 7.23177L14.8874 7.81771C14.9633 7.89366 15.0013 7.99132 15.0013 8.11067C15.0013 8.23003 14.9633 8.32769 14.8874 8.40364L10.0859 13.1888C10.01 13.2756 9.91232 13.319 9.79296 13.319C9.6736 13.319 9.57595 13.2756 9.49999 13.1888Z",
    fill: "#008080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.9a4896d4c09966dd11f2a3da3802a0c9.svg";
export { ForwardRef as ReactComponent };